import type { QueryKey } from "@tanstack/react-query";

/**
 * Query keys for an evidence item's photos (the evidence item Photos tab, read
 * from case_docs through the ENG-1445 routes). Own namespace, like
 * `storagePhotosQueryKeys`, so it never collides with the Case Files keys.
 */
export const evidencePhotosQueryKeys = {
  all: ["evidence-photos"] as QueryKey,
  // list() with no arg is not a prefix of a real list key; use `all` for that.
  list: (evidenceId?: number): QueryKey => [
    "evidence-photos",
    "list",
    { evidence_id: evidenceId },
  ],
};
